<ng-container *transloco="let t; prefix:'customers.customersDetail'">
    <h2 mat-dialog-title class="dialog-header">
        <span class="dialog-title title-large">Modifica dettagli indirizzo</span>

        <button
            mat-icon-button
            type="button"
            aria-label="Chiudi"
            class="close-button"
            (click)="onClose()"
        >
            <i class="fa-regular fa-xmark"></i>
        </button>
    </h2>

    <mat-dialog-content class="content" [formGroup]="editAddressForm">
        <mat-form-field appearance="outline">
            <mat-label>Riferimento</mat-label>
            <input matInput formControlName="riferimento">
        </mat-form-field>

        <!-- <mat-form-field appearance="outline">
            <mat-label>Citta</mat-label>
            <input matInput formControlName="citta">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>CAP</mat-label>
            <input matInput formControlName="cap">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Indirizzo</mat-label>
            <input matInput formControlName="indirizzo">
        </mat-form-field> -->

        <mat-form-field appearance="outline">
            <mat-label>Nota libera</mat-label>
            <input matInput formControlName="nota">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Giorni</mat-label>
            <input matInput formControlName="giorni">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Orari</mat-label>
            <input matInput formControlName="orari">
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Contatto</mat-label>
            <input matInput formControlName="contatto">
        </mat-form-field>

        <mat-checkbox class="sponda-checkbox" formControlName="sponda">
            {{ t('delivery.destinations.notes.tailLift') }}
        </mat-checkbox>

        <!-- <mat-slide-toggle class="bolla-toggle" formControlName="bolla" labelPosition="before">
            <span class="body-small-emphasized">Da mettere in bolla</span>
        </mat-slide-toggle> -->
    </mat-dialog-content>

    <mat-dialog-actions class="buttons-container">
        <button matButton type="button" (click)="onReset()">Resetta</button>
        <button matButton="filled" type="button" (click)="onApply()">Applica</button>
    </mat-dialog-actions>
</ng-container>
